module.exports = __webpack_public_path__ + "media/applicants/door-delivery-d2bb0039.svg";